import React, { Component } from 'react';
import loading from '../components/loading.svg';

class CallbackPage extends Component {

  componentDidMount() {
    if (/access_token|id_token|error/.test(this.props.location.hash)) {
      this.props.checkLogin(this.props.location.hash);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.authenticated !== this.props.authenticated) {
      if (this.props.authenticated) {
        this.props.route.replace("/");
      } else {
        this.props.route.replace("/login");
      }
    } 
    if (prevProps.location.hash !== this.props.location.hash) {
      if (/access_token|id_token|error/.test(this.props.location.hash)) {
        this.props.checkLogin(this.props.location.hash);
      }      
    }
  }

  render() {
    const style = {
      position: 'absolute',
      display: 'flex',
      justifyContent: 'center',
      height: '100vh',
      width: '100vw',
      top: 0,
      bottom: 0,
      left: 0,
      right: 0,
      backgroundColor: 'white',
    }

    return (
      <div style={style}>
        <img src={loading} alt="loading"/>
      </div>
    );
  }
}

export default CallbackPage;